var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.actions,
          "left-side-class": "col-xl-4",
          page: _vm.page,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _vm.showAddCard
        ? _c("add-card", {
            attrs: {
              activate: _vm.showAddCard,
              "card-statuses": _vm.catalog.status
            },
            on: {
              "update:activate": function($event) {
                _vm.showAddCard = $event
              }
            }
          })
        : _vm._e(),
      _c("separator", { staticClass: "my-3" }),
      _c("filter-manager", {
        ref: "attendanceFilterRef",
        staticClass: "mb-4 filter-manager-extended",
        attrs: { "display-advanced": true, filters: _vm.filterManagerConfig },
        on: { search: _vm.onSearchHandler },
        model: {
          value: _vm.filterModel,
          callback: function($$v) {
            _vm.filterModel = $$v
          },
          expression: "filterModel"
        }
      }),
      _c("separator", {
        staticClass: "my-3",
        attrs: { text: "Resultado de Tarjetas" }
      }),
      _vm.result.data.length === 0 ? _c("custom-result-not-found") : _vm._e(),
      _c("search-result", {
        attrs: { "result-data": _vm.result },
        on: {
          "do-search": _vm.getCardsData,
          "on-page-change": _vm.onPageChangeHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }